import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[TimeInput]',
    standalone: false
})
export class TimeInputDirective {
  constructor(
    private el: ElementRef,
    @Optional() @Self() private ngControl: NgControl,
  ) {
  }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = this.el.nativeElement;
    const value = input.value;

    // Remove any non-numeric characters
    let newValue = value.replace(/[^0-9]/g, '');

    // Format single digit to two digits if first digit is greater than 1
    // tslint:disable-next-line:radix
    if (newValue.length === 1 && parseInt(newValue) > 1) {
      newValue = '0' + newValue;
    }
    // Handle 12-hour clock format when first digit is 1
    else if (newValue.length === 2) {
      // tslint:disable-next-line:radix
      const firstDigit = parseInt(newValue[0]);
      // tslint:disable-next-line:radix
      const secondDigit = parseInt(newValue[1]);

      if (firstDigit === 1 && secondDigit > 2) {
        newValue = '12';
      }
    }
    // Add colon after two digits if not already present
    else if (newValue.length === 2 && !newValue.includes(':')) {
      newValue = newValue + ':';
    }
    // If third digit is entered and no colon exists, add colon after second digit
    else if (newValue.length === 3 && !newValue.includes(':')) {
      newValue = newValue.substring(0, 2) + ':' + newValue.substring(2);
    }
    // If four digits are entered and no colon exists, add colon after second digit
    else if (newValue.length === 4 && !newValue.includes(':')) {
      newValue = newValue.substring(0, 2) + ':' + newValue.substring(2);
    }

    // Handle minutes validation
    if (newValue.includes(':')) {
      const parts = newValue.split(':');
      if (parts.length === 2) {
        const minutes = parts[1];
        if (minutes.length >= 1) {
          // tslint:disable-next-line:radix
          const firstMinuteDigit = parseInt(minutes[0]);
          if (firstMinuteDigit > 5) {
            parts[1] = '5' + (minutes.length > 1 ? minutes[1] : '');
          }
        }
        if (minutes.length >= 2) {
          // tslint:disable-next-line:radix
          const secondMinuteDigit = parseInt(minutes[1]);
          if (secondMinuteDigit > 9) {
            parts[1] = minutes[0] + '9';
          }
        }
        newValue = parts.join(':');
      }
    }

    // Update the input value if it changed
    if (value !== newValue) {
      input.value = newValue;
      this.ngControl?.control?.setValue(newValue, { emitEvent: false });
      event.stopPropagation();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    // Handle backspace specifically
    if (event.keyCode === 8) {
      const input = this.el.nativeElement;
      const value = input.value;
      const cursorPosition = input.selectionStart;

      // If cursor is at position 3 (after colon) and backspace is pressed
      if (cursorPosition === 3 && value[2] === ':') {
        // Remove the colon and update the value
        input.value = value.substring(0, 2) + value.substring(3);
        input.setSelectionRange(2, 2);
        event.preventDefault();
        return;
      }
    }

    // Allow: backspace, delete, tab, escape, enter, arrows
    if (
      [46, 8, 9, 27, 13, 37, 38, 39, 40].indexOf(event.keyCode) !== -1 ||
      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true)
    ) {
      return;
    }

    // Ensure that it is a number and stop the keypress
    if (
      (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }
}
